module.exports = __webpack_public_path__ + "media/images/lb/320-7d6c3f789805ecb6b8992d6c4bf79e04.svg";